import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";

import AccountMenu from "./AccountMenuNavigation/AccountMenu";
import VoucherCard from "../../components/account/VoucherCard";
import { getVoucherList, claimVoucher } from "../../service/voucher.service";
import CheckCircleBrokenIcon from "../../assets/images/homepage/check-circle-broken.svg";
import AlertCircle from "../../assets/images/homepage/alert-circle.svg";
import XClose from "../../assets/images/homepage/x-close.svg";
import "../../assets/scss/base/pages/account/Account.scss";
import "../../assets/scss/base/pages/account/Voucher.scss";
import "../../assets/scss/base/pages/global.scss";
import "react-tabs/style/react-tabs.css";
import NotFoundVocuher from "../../assets/images/voucher/not-found.png"
import ReactPaginate from "react-paginate";

const VoucherPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [pages, setPages] = useState({
    available: 1,
    claimed: 1,
    used: 1,
  });
  const [meta, setMeta] = useState({
    available: 1,
    claimed: 1,
    used: 1,
  });
  const limit = 5;

  const getTabIndexFromQuery = () => {
    const tab = query.get("tab");
    if (tab === "claimed") return 1;
    if (tab === "history") return 2;
    return 0;
  };

  const [tabIndex, setTabIndex] = useState(getTabIndexFromQuery());
  const [vouchers, setVouchers] = useState({
    available: [],
    claimed: [],
    used: [],
  });

  const [isLoading, setIsLoading] = useState({
    available: false,
    claimed: false,
    used: false,
  });

  const [claimingVoucherId, setClaimingVoucherId] = useState(null);

  const getTabKey = () => {
    if (tabIndex === 1) return "claimed";
    if (tabIndex === 2) return "used";
    return "available";
  };

  useEffect(() => {
    setTabIndex(getTabIndexFromQuery());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  // Fetch vouchers when tab changes
  useEffect(() => {
    const fetchVouchersForTab = async () => {
      let type = "available";
      let tabKey = "available";

      if (tabIndex === 1) {
        type = "claimed";
        tabKey = "claimed";
      } else if (tabIndex === 2) {
        type = "used";
        tabKey = "used";
      }

      const currentPage = pages[tabKey];

      setIsLoading((prev) => ({ ...prev, [tabKey]: true }));

      try {
        const response = await getVoucherList({
          type: type,
          filter: "",
          page: currentPage,
          limit,
        });

        if (response?.data?.success) {
          setVouchers((prev) => ({
            ...prev,
            [tabKey]: response?.data?.data?.list || [],
          }));
          setMeta((prev) => ({
            ...prev,
            [tabKey]: response?.data?.data?.pages || 0,
          }));
        }
      } catch (error) {
        console.error(`Error fetching ${type} vouchers:`, error);
      } finally {
        setIsLoading((prev) => ({ ...prev, [tabKey]: false }));
      }
    };

    fetchVouchersForTab();
  }, [tabIndex, pages]);

  const handleTabChange = (index) => {
    setTabIndex(index);
    const tabKey =
      index === 0 ? "available" :
        index === 1 ? "claimed" : "used";

    setPages((prev) => ({
      ...prev,
      [tabKey]: 1,
    }));
    const tabText = index === 0 ? "available" : index === 1 ? "claimed" : "history";
    navigate(`?tab=${tabText}`);
  };

  const handleClaimVoucher = async (voucher) => {
    setClaimingVoucherId(voucher.id);
    try {
      const response = await claimVoucher({ id: voucher.id });

      if (response?.data?.success) {
        // Show success toast
        toast(
          (t) => (
            <div className="toast__block">
              <div className="toast__block__icon">
                <img src={CheckCircleBrokenIcon} alt="" />
              </div>
              <h4 style={{ marginTop: "0.5rem" }}>
                Voucher claimed successfully
              </h4>
              <button onClick={() => toast.dismiss(t.id)}>
                <img src={XClose} alt="" />
              </button>
            </div>
          ),
          {
            style: {
              borderRadius: "10px",
              background: "#12B76A",
              color: "#C5F6DF",
            },
          }
        );

        // Refresh only available vouchers after successful claim
        try {
          const availableResponse = await getVoucherList({
            type: "available",
            filter: "",
          });

          if (availableResponse?.data?.success) {
            setVouchers((prev) => ({
              ...prev,
              available: availableResponse?.data?.data?.list || [],
            }));
          }
        } catch (error) {
          console.error("Error refreshing available vouchers:", error);
        }
      } else {
        // Show error toast
        toast(
          (t) => (
            <div className="toast__block">
              <div className="toast__block__icon">
                <img src={AlertCircle} alt="" />
              </div>
              <h4 style={{ marginTop: "0.5rem" }}>
                {response?.data?.errorMessage || "Failed to claim voucher"}
              </h4>
              <button onClick={() => toast.dismiss(t.id)}>
                <img src={XClose} alt="" />
              </button>
            </div>
          ),
          {
            style: {
              borderRadius: "10px",
              background: "#D92D20",
              color: "#FFD7D3",
            },
          }
        );
      }
    } catch (error) {
      console.error("Error claiming voucher:", error);
      toast(
        (t) => (
          <div className="toast__block">
            <div className="toast__block__icon">
              <img src={AlertCircle} alt="" />
            </div>
            <h4 style={{ marginTop: "0.5rem" }}>
              Error claiming voucher. Please try again.
            </h4>
            <button onClick={() => toast.dismiss(t.id)}>
              <img src={XClose} alt="" />
            </button>
          </div>
        ),
        {
          style: {
            borderRadius: "10px",
            background: "#D92D20",
            color: "#FFD7D3",
          },
        }
      );
    } finally {
      setClaimingVoucherId(null);
    }
  };

  const handlePageClick = (event) => {
    const tabKey = getTabKey();

    setPages((prev) => ({
      ...prev,
      [tabKey]: event.selected + 1,
    }));
  };

  return (
    <AccountMenu>
      <div className="profile-details-parentAccount">
        <h3 className="accountAccount">Voucher</h3>
        <div className="voucher__block">
          <Tabs selectedIndex={tabIndex} onSelect={handleTabChange}>
            <TabList>
              <Tab>Available Voucher</Tab>
              <Tab>Claimed Voucher</Tab>
              <Tab>Voucher History</Tab>
            </TabList>

            <TabPanel>
              {isLoading.available ? (
                <div className="no-voucher">Loading...</div>
              ) : vouchers.available.length > 0 ? (
                <>
                  <div className="voucher-list-wrapper">
                    {vouchers.available.map((voucher) => (
                      <VoucherCard
                        key={voucher.id}
                        voucher={voucher}
                        onClaim={handleClaimVoucher}
                        showClaimButton={true}
                        isClaiming={claimingVoucherId === voucher.id}
                        isClaimed={false}
                        isHistory={false}
                      />
                    ))}
                  </div>
                  {meta[getTabKey()] > 1 && (
                    <ReactPaginate
                      pageCount={meta[getTabKey()] || 0}
                      onPageChange={handlePageClick}
                      previousLabel={"Prev"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      containerClassName={"voucherPagination"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"previous"}
                      nextClassName={"next"}
                      activeClassName={"selected"}
                      disabledClassName={"disabled"}
                      forcePage={Math.min(
                        (pages[getTabKey()] || 1) - 1,
                        (meta[getTabKey()] || 1) - 1
                      )}
                    />
                  )}
                </>
              ) : (
                <div className="no-voucher">
                  <img src={NotFoundVocuher} alt="Not Found" />
                  <p>No Vouchers at this moment</p>
                  <p>Get Back Next Time</p>
                </div>
              )}
            </TabPanel>

            <TabPanel>
              {isLoading.claimed ? (
                <div className="no-voucher">Loading...</div>
              ) : vouchers.claimed.length > 0 ? (
                <>
                  <div className="voucher-list-wrapper">
                    {vouchers.claimed.map((voucher) => (
                      <VoucherCard
                        key={voucher.id}
                        voucher={voucher}
                        onClaim={handleClaimVoucher}
                        showClaimButton={false}
                        isClaiming={false}
                        isClaimed={true}
                        isHistory={false}
                      />
                    ))}
                  </div>
                  {meta[getTabKey()] > 1 && (
                    <ReactPaginate
                      pageCount={meta[getTabKey()] || 0}
                      onPageChange={handlePageClick}
                      previousLabel={"Prev"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      containerClassName={"voucherPagination"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"previous"}
                      nextClassName={"next"}
                      activeClassName={"selected"}
                      disabledClassName={"disabled"}
                      forcePage={Math.min(
                        (pages[getTabKey()] || 1) - 1,
                        (meta[getTabKey()] || 1) - 1
                      )}
                    />
                  )}
                </>
              ) : (
                <div className="no-voucher">
                  <img src={NotFoundVocuher} alt="Not Found" />
                  <p>No Vouchers at this moment</p>
                  <p>Get Back Next Time</p>
                </div>
              )}
            </TabPanel>

            <TabPanel>
              {isLoading.used ? (
                <div className="no-voucher">Loading...</div>
              ) : vouchers.used.length > 0 ? (
                <>
                  <div className="voucher-list-wrapper">
                    {vouchers.used.map((voucher) => (
                      <VoucherCard
                        key={voucher.id}
                        voucher={voucher}
                        onClaim={handleClaimVoucher}
                        showClaimButton={false}
                        isClaiming={false}
                        isClaimed={false}
                        isHistory={true}
                      />
                    ))}
                  </div>
                  {meta[getTabKey()] > 1 && (
                    <ReactPaginate
                      pageCount={meta[getTabKey()] || 0}
                      onPageChange={handlePageClick}
                      previousLabel={"Prev"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      containerClassName={"voucherPagination"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"previous"}
                      nextClassName={"next"}
                      activeClassName={"selected"}
                      disabledClassName={"disabled"}
                      forcePage={Math.min(
                        (pages[getTabKey()] || 1) - 1,
                        (meta[getTabKey()] || 1) - 1
                      )}
                    />
                  )}
                </>
              ) : (
                <div className="no-voucher">
                  <img src={NotFoundVocuher} alt="Not Found" />
                  <p>No Vouchers at this moment</p>
                  <p>Get Back Next Time</p>
                </div>
              )}
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </AccountMenu>
  );
};

export default VoucherPage;
